import type {
    TCollaborateColorScheme,
    TColorScheme,
    TFullColorScheme,
} from 'src/shared/types/color-schemes-and-themes';
import type { ICommonWidgetData } from 'src/shared/types/common-widget-data';

export interface IViewOptions {
    viewType: 'banner' | 'fullScreen';
    underlayColor: TColorScheme | TCollaborateColorScheme;
    fullScreenSpacing?: '3x' | '7x';
}

export interface Widget {
    class_name: string;
    anchorId?: string;
    commonWidgetData?: ICommonWidgetData;
    viewOptions?: IViewOptions;
    isWidgetConfig?: boolean;
    isMobileHidden: boolean | null;
    isDesktopHidden: boolean | null;
    hasWrapper?: boolean;
    personalizationData?: IPersonalisationData;
}

export interface WidgetInputData {
    [key: string]: unknown;
}

export interface IPage {
    widgets: (Widget & WidgetInputData)[] | ISidebarPageWidget;
    layout?: {
        name?: string;
    };
}

export interface ISidebarPageWidget {
    before_sidebar: (Widget & WidgetInputData)[];
    sidebar: (Widget & WidgetInputData)[];
    after_sidebar: (Widget & WidgetInputData)[];
}

export enum ELayoutType {
    Full = 'full',
    Sidebar = 'sidebar',
}

export interface IPersonalisationData {
    dynamicHeadline?: string;
}

export type TRenderContext = 'default' | 'sidebar';

export type Viewport = 'mobile' | 'desktop';

export type WidgetList = (Widget & WidgetInputData)[];

export interface VisibleWidgetRef {
    widget: Widget & WidgetInputData;
    index: number;
}

export interface ViewportFlags {
    mobile: boolean;
    desktop: boolean;
}

export interface WidgetLayoutEntry {
    widget: Widget & WidgetInputData;
    index: number;
    hasWrapper: boolean;
    renderContext: TRenderContext;
    reducedTopSpacing: ViewportFlags;
    figuredBackgroundAllowed: ViewportFlags;
}

export type GetWidgetColorScheme = (widget: Widget & WidgetInputData) => TFullColorScheme | undefined;

export interface WidgetSpacingContext {
    widgets: (Widget & WidgetInputData)[];
    isSidebarLayout: boolean;
    widgetsNotSupportedReduceSpacings: string[];
    getWidgetColorScheme: GetWidgetColorScheme;
}
